module.exports = __webpack_public_path__ + "img/132.07933f83.png";